import RentalCategoryPage from "@/components/AircraftRentalCategoryPage";

const rentalCategories = [
  "Monomotor cu piston",
  "Bimotor cu piston",
  "Avion Ultraușor",
  "Elicopter cu piston",
  "Elicopter cu piston",
];

const AircraftRentalList = () => {
  return (
    <RentalCategoryPage
      title="Flotă Închirieri"
      categories={rentalCategories}
    />
  );
};

export default AircraftRentalList;